import { ROUTES } from 'constants/routes';

export const NAV_LIST = [
  {
    label: 'News',
    link: ROUTES.news,
  },
  {
    label: 'Find pet',
    link: `${ROUTES.notices}`,
  },
  {
    label: 'Our friends',
    link: ROUTES.friends,
  },
];
